import ServiceCollabaxFilter from "../../Components/Filters/ServiceCollabaxFilter";
import React, { useState, useEffect, useRef } from "react";
import Card from "../../Components/scvpu/rsaDashboard/Card";
import CardSkeleton from "../../Components/scvpu/rsaDashboard/CardSkeleton";
import Accordian from "../../Components/scvpu/rsaDashboard/Accordian";
import ServiceRevenuePenetrationData from "../../Components/scvpu/rsaDashboard/ServiceRevenuePenetrationData";
import totalBaysImg from "../../Artifacts/scvpu/rsmDashboard/total_bays_img.svg";
import totalScvBays from "../../Artifacts/scvpu/rsmDashboard/total_scv_bays.svg";
import serviceRevenuePenetration from "../../Artifacts/scvpu/rsmDashboard/service_revenue_penetration_img.svg";
import dealerProfitablity from "../../Artifacts/scvpu/rsmDashboard/dealer_profitability.svg";
import serviceQuality from "../../Artifacts/scvpu/rsmDashboard/service_quality.svg";
import DealerProfitablility from "../../Components/scvpu/rsaDashboard/DealerProfitablility";
import CustomerExperience from "./ServiceCollabaxStatics/ServiceExperience";

import DealerServiceRevenuePenetration from "./ServiceCollabaxStatics/DealerServiceRevenuePenetration";
import DealerServiceRevenueStreams from "./ServiceCollabaxStatics/DealerRevenueStreams";
import OperationalEffcienecy from "./ServiceCollabaxStatics/OperationalEffcienecy";
import html2canvas from "html2canvas";
import { FaFileDownload } from "react-icons/fa";
import { jsPDF } from "jspdf";
import Tata from "../../Artifacts/tata-motors-white.svg";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { axInst } from "../../Components/Login/Service";

export const fetchRsmCardsData = async (filterData) => {
  const { data } = await axInst.post(
    "collbax-service/collbax_service_rsm_card",
    filterData,
  );
  return data;
};

const DealerServiceCollabax = () => {
  const [isExporting, setIsExporting] = useState(false);
  const dashboardRef = useRef(null);

  const { data: filterData, submitted } = useSelector(
    (state) => state.filtersServiceCollabax,
  );

  const payload = {
    ...filterData,
    Partner_Type: ["Dealer"],
  };

  const {
    data: rsmCardData,
    isLoading: rsmCardLoading,
    isFetching: rsmCardFetching,
  } = useQuery({
    queryKey: ["rsmCardsData", payload],
    queryFn: () => fetchRsmCardsData(payload),
  });

  const isLoading = rsmCardLoading || rsmCardFetching;

  const filterLabels = {
    region: "Region",
    state: "State",
    state_office: "State Office",
    Rsm_Name: "RSM",
    Partner_Type: "Partner Type",
    dealer_tag: "Category",
    dealer_name: "Dealer Name",
    dealer_code: "Dealer Code",
    division_name: "Division",
    Product_Line: "Product Line",
    lob: "LOB",
    ppl: "PPL",
    pl: "PL",
  };

  const activeFilters = Object.entries(filterData || {}).filter(
    ([key, value]) => value && value.length > 0,
  );

  const renderActiveFilters = () => {
    if (activeFilters.length === 0) return null;
    return (
      <div className="flex flex-wrap gap-x-4 gap-y-2 p-2 bg-white w-full rounded-b-md text-left">
        {activeFilters.map(([key, value]) => (
          <div
            key={key}
            className="text-sm text-[#2A5775] flex bg-gray-50 border border-gray-200 px-2 py-1 rounded"
          >
            <span className="font-bold mr-1">{filterLabels[key] || key}: </span>
            <span className="font-normal">{value.join(", ")}</span>
          </div>
        ))}
      </div>
    );
  };

  const cardsData = [
    {
      icon: totalBaysImg,
      title: "Total BAYS",
      value: rsmCardData?.total_bays || 0,
    },
    {
      icon: totalScvBays,
      title: "Total SCV BAYS",
      value: rsmCardData?.total_scv_bays || 0,
    },
  ];

  const handleExportPDF = async () => {
    if (isExporting) return;
    setIsExporting(true);

    try {
      const element = dashboardRef.current;
      if (!element) return;

      const pdfHeader = element.querySelector("[data-pdf-header]");
      const kpiCards = element.querySelector("[data-pdf-cards]");
      const accordions = element.querySelectorAll(
        "[data-pdf-accordion-wrapper]",
      );

      // Temporarily force all accordions to be visible and expanded
      const accordionDivs = element.querySelectorAll(
        "[data-accordion-content]",
      );
      const originalStyles = [];

      accordionDivs.forEach((div) => {
        originalStyles.push({
          el: div,
          height: div.style.height,
          opacity: div.style.opacity,
          visibility: div.style.visibility,
          overflow: div.style.overflow,
        });
        div.style.height = "auto";
        div.style.opacity = "1";
        div.style.visibility = "visible";
        div.style.overflow = "visible";
      });

      // Show PDF header temporarily for capture
      if (pdfHeader) pdfHeader.style.display = "flex";

      // Trigger resize event to force Echarts charts to re-render
      window.dispatchEvent(new Event("resize"));
      await new Promise((resolve) => setTimeout(resolve, 2000));

      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const contentWidth = pdfWidth - 2 * margin;

      let currentY = 0;

      const captureAndAddHeader = async () => {
        if (!pdfHeader) return 0;
        const canvas = await html2canvas(pdfHeader, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * contentWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", margin, 5, contentWidth, imgHeight);
        return imgHeight + 10; // Return height plus some spacing
      };

      const captureAndAddElement = async (el, yOffset) => {
        if (!el) return 0;
        const canvas = await html2canvas(el, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * contentWidth) / canvas.width;

        // Check if it fits on current page
        if (yOffset + imgHeight > pdfHeight - margin) {
          pdf.addPage();
          yOffset = await captureAndAddHeader();
        }

        pdf.addImage(imgData, "PNG", margin, yOffset, contentWidth, imgHeight);
        return imgHeight;
      };

      // --- Start Generation ---

      // Page 1: Header + Cards
      currentY = await captureAndAddHeader();
      const cardsHeight = await captureAndAddElement(kpiCards, currentY);
      currentY += cardsHeight + 5;

      // Process Accordions
      for (let i = 0; i < accordions.length; i++) {
        const acc = accordions[i];
        const accHeader = acc.querySelector("[data-pdf-accordion-header]");
        const charts = acc.querySelectorAll("[data-pdf-chart]");

        // Except for first accordion, start a new page
        if (i > 0) {
          pdf.addPage();
          currentY = await captureAndAddHeader();
        }

        // Add Accordion Header
        const accHeaderHeight = await captureAndAddElement(accHeader, currentY);
        currentY += accHeaderHeight + 2;

        // Process Charts in groups of 3 (rows) and enforce 15 charts per page
        const step = 3;
        const chartsOnCurrentPageLimit = 15;
        let chartsOnCurrentPage = 0;
        const chartsArray = Array.from(charts);

        if (chartsArray.length === 0) {
          // Fallback: If no charts are tagged, capture the entire accordion content area
          const accordionContent = acc.querySelector(
            "[data-accordion-content]",
          );
          if (accordionContent) {
            await captureAndAddElement(accordionContent, currentY);
          }
        } else {
          for (let j = 0; j < chartsArray.length; j += step) {
            // Check if adding this row exceeds 15 charts on the current page
            if (chartsOnCurrentPage >= chartsOnCurrentPageLimit) {
              pdf.addPage();
              currentY = await captureAndAddHeader();
              const repeatedHeaderHeight = await captureAndAddElement(
                accHeader,
                currentY,
              );
              currentY += repeatedHeaderHeight + 2;
              chartsOnCurrentPage = 0;
            }

            // Capture the row (step charts)
            const rowCharts = chartsArray.slice(j, j + step);
            if (rowCharts.length === 0) continue;

            const firstChartRect = rowCharts[0].getBoundingClientRect();
            const dashboardRect = element.getBoundingClientRect();

            const x = 0; // Use full horizontal strip
            const y = firstChartRect.top - dashboardRect.top;
            const width = element.clientWidth;
            const height =
              Math.max(...rowCharts.map((c) => c.offsetHeight)) + 4; // Add slight padding

            const rowCanvas = await html2canvas(element, {
              scale: 2,
              useCORS: true,
              x: x,
              y: y,
              width: width,
              height: height,
              scrollX: 0,
              scrollY: 0,
              windowWidth: element.scrollWidth,
              windowHeight: element.scrollHeight,
            });

            const rowImgData = rowCanvas.toDataURL("image/png");
            const rowImgHeight =
              (rowCanvas.height * contentWidth) / rowCanvas.width;

            // Handle page break if row doesn't fit
            if (currentY + rowImgHeight > pdfHeight - margin) {
              pdf.addPage();
              currentY = await captureAndAddHeader();
              const repeatedHeaderHeight = await captureAndAddElement(
                accHeader,
                currentY,
              );
              currentY += repeatedHeaderHeight + 2;
              chartsOnCurrentPage = 0; // Reset count since it's a new page
            }

            pdf.addImage(
              rowImgData,
              "PNG",
              margin,
              currentY,
              contentWidth,
              rowImgHeight,
            );
            currentY += rowImgHeight + 2;
            chartsOnCurrentPage += rowCharts.length;
          }
        }
      }

      // Restore everything
      originalStyles.forEach((s) => {
        s.el.style.height = s.height;
        s.el.style.opacity = s.opacity;
        s.el.style.visibility = s.visibility;
        s.el.style.overflow = s.overflow;
      });

      if (pdfHeader) pdfHeader.style.display = "none";
      window.dispatchEvent(new Event("resize"));

      pdf.save("Dealer_Dashboard_Export.pdf");
    } catch (error) {
      console.error("PDF Export failed", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex flex-col flex-grow p-2">
      {isExporting && (
        <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center pointer-events-none">
          <div className="bg-white p-6 rounded-lg shadow-xl flex flex-col items-center gap-4">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#2a5775]"></div>
            <p className="font-semibold text-[#2a5775]">Generating PDF...</p>
            <p className="text-sm text-gray-500">
              Capturing all graphs, please wait.
            </p>
          </div>
        </div>
      )}

      <div className="relative">
        <div className="print:hidden flex flex-col md:flex-row  justify-between gap-1 w-full">
          <div className="w-full md:w-[95%] ">
            <ServiceCollabaxFilter />
          </div>
          <button
            type="button"
            onClick={handleExportPDF}
            title="Export PDF"
            className="bg-[#2A5775] w-full md:w-[5%] text-center justify-center flex md:flex-col text-white p-2  items-center text-xs font-semibold gap-2 rounded-md"
          >
            Export PDF
            <FaFileDownload className="text-lg" />
          </button>
        </div>
        <div ref={dashboardRef} className="w-full max-w-full mt-2 ">
          <div
            data-pdf-header
            style={{ display: "none" }}
            className="flex flex-col w-full my-2 bg-white rounded-md border border-[#2A5775]"
          >
            <div className="bg-[#2A5775] text-xl flex items-center justify-between px-4 text-center w-full text-white font-bold p-2">
              <img
                src={Tata}
                alt="Tata Motors"
                loading="eager"
                className="h-[42px] w-auto"
              />
              <span>Snapshot for Dealer Dashboard</span>
              <div className="w-[42px]"></div>
            </div>
            {renderActiveFilters()}
          </div>
          <div
            data-pdf-cards
            className="grid text-sm grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 "
          >
            {isLoading
              ? Array(2)
                  .fill(0)
                  .map((_, index) => <CardSkeleton key={index} />)
              : cardsData.map((card, index) => (
                  <Card
                    key={index}
                    title={card.title}
                    value={card.value}
                    icon={card.icon}
                  />
                ))}
          </div>
          <div className="flex mt-2 flex-col gap-6">
            <Accordian
              icon={serviceRevenuePenetration}
              title="Service Revenue Penetration"
            >
              <DealerServiceRevenuePenetration />
            </Accordian>
            <Accordian icon={dealerProfitablity} title="Revenue Streams">
              <DealerServiceRevenueStreams />
            </Accordian>
            <Accordian icon={serviceQuality} title="Operational Efficiency">
              <OperationalEffcienecy />
            </Accordian>
            <Accordian icon={serviceQuality} title="Customer Experience">
              <CustomerExperience />
            </Accordian>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealerServiceCollabax;
